var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEslintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.353 24.35l12.155-7.018a.98.98 0 0 1 .983 0l12.156 7.018c.304.176.492.5.492.852V39.24c0 .35-.188.676-.492.852L32.49 47.1a.98.98 0 0 1-.983 0L19.353 40.1c-.304-.176-.492-.5-.492-.852V25.203c0-.35.188-.676.492-.852",
    fill: "#8080f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.604 30.744L49.08 5.478c-.527-.914-1.5-1.578-2.556-1.578H17.477c-1.055 0-2.03.674-2.557 1.587L.396 30.7a3 3 0 0 0 0 2.98L14.92 58.73c.528.914 1.502 1.38 2.557 1.38h29.047c1.055 0 2.03-.453 2.557-1.367l14.523-25.1a2.85 2.85 0 0 0 0-2.898m-12.026 12.15c0 .37-.224.715-.546.9l-18.5 10.673a1.05 1.05 0 0 1-1.047 0L12.972 43.795c-.322-.186-.547-.53-.547-.9V21.547a1.06 1.06 0 0 1 .544-.9l18.5-10.673a1.05 1.05 0 0 1 1.046 0L51.03 20.646c.322.186.55.53.55.9z",
    fill: "#4b32c3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEslintIcon);
export default __webpack_public_path__ + "static/media/eslint-icon.f10edf034389ee615a371b6695f831b0.svg";
export { ForwardRef as ReactComponent };